module.exports = __webpack_public_path__ + "img/girl25.2faaf9d4.png";